import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// GET access controls

const getAccessControl = (state: AppState) => state.accessControl;

export const getAccessControlSelector = createSelector(getAccessControl, (accessControl) => accessControl.accessControls);
export const getAccessControlPendingSelector = createSelector(getAccessControl, (accessControl) => accessControl.pending);

// POST data source

const postDataPending = (state: AppState) => state.postDataSource.pending;
const postDataSource = (state: AppState) => state.postDataSource.dataSource;
const postDataError = (state: AppState) => state.postDataSource.error;

export const postDataPendingSelector = createSelector(postDataPending, (pending) => pending);
export const postDataSelector = createSelector(postDataSource, (dataSource) => dataSource);
export const postDataErrorSelector = createSelector(postDataError, (error) => error);


// PUT data source

const putDataPending = (state: AppState) => state.putDataSource.pending;
const putDataSource = (state: AppState) => state.putDataSource.dataSource;
const putDataError = (state: AppState) => state.putDataSource.error;

export const putDataPendingSelector = createSelector(putDataPending, (pending) => pending);
export const putDataSelector = createSelector(putDataSource, (dataSource) => dataSource);
export const putDataErrorSelector = createSelector(putDataError, (error) => error);


// source list 

const getSourcesListPending = (state: AppState) => state.sources.pending;
const getSourcesList = (state: AppState) => state.sources.sources;
const getSourcesListError = (state: AppState) => state.sources.error;

export const getSourcesListSelector = createSelector(getSourcesList, (sources) => sources);
export const getSourcesListPendingSelector = createSelector(getSourcesListPending,(pending) => pending);
export const getSourcesListErrorSelector = createSelector(getSourcesListError, (error) => error);

// GET source

const getSourceDetailsPending = (state: AppState) => state.sourceDetails.pending;
const getSourceDetails = (state: AppState) => state.sourceDetails.source;
const getSourceDetailsError = (state: AppState) => state.sourceDetails.error;

export const getSourceSelector = createSelector(getSourceDetails, (source) => source);
export const getSourcePendingSelector = createSelector(getSourceDetailsPending,(pending) => pending);
export const getSourceErrorSelector = createSelector(getSourceDetailsError, (error) => error);

// DELETE source

const deleteSourcePending = (state: AppState) => state.deleteDataSource.pending;
const deleteSource = (state: AppState) => state.deleteDataSource.success;
const deleteSourceError = (state: AppState) => state.deleteDataSource.error;

export const deleteSourceSelector = createSelector(deleteSource, (source) => source);
export const deleteSourcePendingSelector = createSelector(deleteSourcePending,(pending) => pending);
export const deleteSourceErrorSelector = createSelector(deleteSourceError, (error) => error);

// POST connection

const postConnectionPending = (state: AppState) => state.connection.pending;
const postConnection = (state: AppState) => state.connection.succeeded;
const postConnectionError = (state: AppState) => state.connection.error;

export const postConnectionPendingSelector = createSelector(postConnectionPending, (pending) => pending);
export const postConnectionSelector = createSelector(postConnection, (succeeded) => succeeded);
export const postConnectionErrorSelector = createSelector(postConnectionError, (error) => error);

// GET user: Data Stewards

const getPendingSteward = (state: AppState) => state.steward.pending;
const getStewardData = (state: AppState) => state.steward.userName;
const getErrorSteward = (state: AppState) => state.steward.error;

export const getStewardSelector = createSelector(getStewardData, (userData) => userData);
export const getStewardPendingSelector = createSelector(getPendingSteward,(pending) => pending);
export const getStewardErrorSelector = createSelector(getErrorSteward, (error) => error);